

export const updatePhoneSetting = async (updateField, updateValue) => {

    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone || "America/New_York";

    try {
        const response = await fetch('https://functionappfordev.azurewebsites.net/api/phoneSettingsHandler?method=UPDATE', {
            method: 'POST',
            headers: { 
                'Content-Type': 'application/json',
                'X-UserSessionID': localStorage.getItem('UserSessionID') || ''
             },
             body: JSON.stringify({
                updateField,
                updateValue,
                timeZone
             })
            // body: JSON.stringify({ CompanyID, ClientID }),
            // credentials: 'include' // Include credentials for CORS
        });

        if (!response.ok) {
            throw new Error('Failed to fetch tokens');
        }

        const data = await response.json();
        return data;
    } catch (error) {
        throw new Error('Error updating phone setting:', error);
    }

  }
